module.exports = __webpack_public_path__ + "img/design-hochladen.368d4621.svg";